import { InjectedConnector } from '@web3-react/injected-connector'
import { blockchain } from 'config/blockchain'

export const injected = new InjectedConnector({
	supportedChainIds: Object.keys(blockchain).map(chain => Number(chain))
})
